/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * PermissionGroups enum for ITKCOR.
 */
export enum ITKCORPermissionGroups {
    /**
     * PermissionGroupXYZ
     */
    SomePermissionGroupXYZ = 201000,
    /**
     * PermissionGroupZYX
     */
    SomePermissionGroupZYX = 202000,
}
